module.exports = __webpack_public_path__ + "img/logo_high_res.98566d2b.png";